"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAttributeFilterHandlerStore = void 0;
var tslib_1 = require("tslib");
// (C) 2022-2023 GoodData Corporation
var toolkit_1 = require("@reduxjs/toolkit");
var redux_saga_1 = tslib_1.__importDefault(require("redux-saga"));
var slice_1 = require("./slice");
var rootSaga_1 = require("./rootSaga");
var state_1 = require("./state");
var sdk_model_1 = require("@gooddata/sdk-model");
var nonSerializableActions = [
    slice_1.actions.loadAttributeError.type,
    slice_1.actions.loadInitialElementsPageError.type,
    slice_1.actions.loadNextElementsPageError.type,
    slice_1.actions.loadCustomElementsError.type,
    slice_1.actions.initError.type,
];
// We cannot handle event listeners inside saga, as once the root saga is canceled,
// take effects are not working anymore, but we may want to listen for actions,
// that can be fired even during the "cleanup" phase, after the cancelation.
var eventListeningMiddleware = function (eventListener) {
    return function (store) {
        return function (next) {
            return function (action) {
                // First dispatch the action, so we have already updated store in the event listeners.
                var result = next(action);
                eventListener(result, function (selector) { return selector(store.getState()); });
                return result;
            };
        };
    };
};
/**
 * @internal
 */
function createAttributeFilterHandlerStore(context) {
    var sagaMiddleware = redux_saga_1.default({
        context: {
            attributeFilterContext: context,
        },
    });
    var displayFormRef = sdk_model_1.filterObjRef(context.attributeFilter);
    var elements = sdk_model_1.filterAttributeElements(context.attributeFilter);
    var elementsForm = sdk_model_1.isAttributeElementsByValue(elements) ? "values" : "uris";
    var elementKeys = sdk_model_1.isAttributeElementsByValue(elements) ? elements.values : elements.uris;
    var isInverted = sdk_model_1.isNegativeAttributeFilter(context.attributeFilter);
    var store = toolkit_1.configureStore({
        preloadedState: tslib_1.__assign(tslib_1.__assign({}, state_1.initialState), { displayFormRef: displayFormRef,
            elementsForm: elementsForm, selection: {
                commited: {
                    keys: elementKeys,
                    isInverted: isInverted,
                },
                working: {
                    keys: elementKeys,
                    isInverted: isInverted,
                },
            }, config: {
                hiddenElements: context.hiddenElements,
                staticElements: context.staticElements,
            } }),
        reducer: slice_1.sliceReducer,
        middleware: function (getDefaultMiddleware) {
            return getDefaultMiddleware({
                thunk: false,
                serializableCheck: {
                    ignoredActions: nonSerializableActions,
                    ignoredPaths: [
                        "initialization.error",
                        "attribute.error",
                        "elements.initialPageLoad.error",
                        "elements.nextPageLoad.error",
                    ],
                },
            }).concat([sagaMiddleware, eventListeningMiddleware(context.eventListener)]);
        },
    });
    var rootSagaTask = sagaMiddleware.run(rootSaga_1.rootSaga);
    return {
        context: context,
        cancelRootSaga: function () {
            rootSagaTask.cancel();
        },
        dispatch: function (action) {
            store.dispatch(action);
        },
        select: function (selector) {
            return selector(store.getState());
        },
    };
}
exports.createAttributeFilterHandlerStore = createAttributeFilterHandlerStore;
//# sourceMappingURL=createStore.js.map